import ReactDOM from "react-dom";

import "./PopupMessage.scss";

const PopupMessage = ({ text }) => {
  return (
    <div className="popup-message--container">
      <div className="popup-message--content">
        <div>{text}</div>
      </div>
    </div>
  );
};

export default PopupMessage;
